import axios from "axios";


export const diagram_meter_data = async (siteId) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-latest-others/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { site_id: siteId }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching site details:', error);
        return null;
    }
};
